export default import.meta.ROLLUP_FILE_URL_EZkHyp3THfFsQutBqX6ozA;